import TopNavigation from 'layout/MainLayout/TopNavigation';
import Footer from 'layout/MainLayout/Footer';
import { Outlet } from 'react-router-dom';
import useMaintenance from 'hooks/useMaintenance';
import MaintenancePage from 'views/pages/maintenance';
import BlockingLoader from 'ui-component/BlockingLoader';
import { useSelector } from 'react-redux';

// ==============================|| MINIMAL LAYOUT ||============================== //

const MinimalLayout = ({never_blocked=false}) => {

    useMaintenance()

    const market_config = useSelector((state) => state?.shop?.config);

    return(
    <>
        <TopNavigation />
            {!!never_blocked ? <Outlet/> :<> 
                {!market_config ? <BlockingLoader text="Loading ..." /> : !never_blocked && !!market_config?.maintenance_mode ? <MaintenancePage/> : <Outlet />}
            </>
            }
        <Footer />
    </>);
};

export default MinimalLayout;
